import ImageLink from 'atoms/image-link';
import { imagify } from 'server/routes/seo/helpers';
import PropTypes from 'prop-types';
import React from 'react';


export default function PlacesContainer({ places, id }) {
  const colors = ['-green', '-blue', '-yellow', '-purple', '-blue-dark', '-gray'];
  const links = [];
  places.forEach((place, i) => {
    links.push(
      <li key={ `landing-page__places-container__item-${i}` } className="landing-page__places-container__item">
        <ImageLink
          className="landing-page__places-container__item__element"
          color={ colors[Math.floor(Math.random() * colors.length)] }
          href={ place.url.endsWith('/') ? place.url : `${place.url}/` }
          imageUrl={ imagify(place.image, 1200) }
          target={ place.location }
        >
          { place.location }
        </ImageLink>
      </li>
    );
  });

  return (
    <section
      className="landing-page__places-container"
      id={ id }
      name={ id }
    >
      <div className="landing-page__places-container__container">
        <ul
          className="landing-page__places-container__inocuos-container"
          style={ { width: places.length * (150 + 10) } }
        >
          { links }
        </ul>
      </div>
    </section>
  );
}

PlacesContainer.defaultProps = {
  id: null,
};

PlacesContainer.propTypes = {
  id: PropTypes.string,
  places: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      location: PropTypes.string,
      target: PropTypes.string,
      url: PropTypes.string,
    })
  ).isRequired,
};
